import { IdName } from './app';
import { Asset } from './asset';
import { MediaCore } from './media';

export enum ChannelId {
  front = 1,
  internal,
  dome,
}

export interface EventCore {
  _id: string;
  ident: string;
  eventName: string;
  created: number;
  status: number; // The status type
  statusDisplay: string; // The status type name
  totalAlarms: number;
  lastAlarm: LastAlarm;
  asset?: Asset;
}

export interface Event extends Omit<EventCore, 'lastAlarm'> {
  alarms: EventAlarm[];
  ignitionStatus: boolean;
  continuousDriving: number;
  suggestedCooldown: number;
  cs: {
    geoReference: string;
    latitude: number;
    longitude: number;
    direction: number;
    speed: number;
    timestamp: number;
    engineIgnitionStatus: boolean;
  };
  evidences: EventEvidenceFile[];
  sgptEventOptions: AttendEventReason[];
}

export interface EventType extends IdName {}

export interface AttendEventReason {
  code: string;
  name: string;
}

export interface AttendEventRequest {
  code: string;
}

export interface EventAlarm {
  alarmType: number;
  gpsAngle: number;
  gpsLat: number;
  gpsLng: number;
  gpsSpeed: number;
  startTime: number;
}

export type LastAlarm = Omit<EventAlarm, 'evidences'>;

export interface EventEvidenceFile extends MediaCore {
  created: number;
}

export interface EventAlarmType {
  code: number;
  name: string;
  color: string;
  active: boolean;
  iconKey?: string;
}
